import axios from 'axios';
import React, { useEffect, useState } from 'react';
import {useCookies} from 'react-cookie';
import DefaultLoader from '../../components/loader/DefaultLoader';
import _ from 'lodash';
import DistributionChart from '../../components/chart/DistributionChart';
import dateSetting from '../../utils/dateSetting';
import ballImage from '../../assets/img/icon/ball_icon.png';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';

function PitchDistributionChartMain({profile}) {
    const ballCodeObj = {
        Fastball: {ballCode: 'Fastball', ballName: '직구', color: '#5fad56'},
        Splitter: {ballCode: 'Splitter', ballName: '포크', color: '#D61355'},
        Slider: {ballCode: 'Slider', ballName: '슬라', color: '#f2c14e'},
        Sinker: {ballCode: 'Sinker', ballName: '투심', color: '#30E3DF'},
        ChangeUp: {ballCode: 'ChangeUp', ballName: '체인', color: '#645CBB'},
        Curveball: {ballCode: 'Curveball', ballName: '커브', color: '#f78154'},
        Cutter: {ballCode: 'Cutter', ballName: '커터', color: '#4d9078'},
        Other: {ballCode: 'Other', ballName: '기타', color: '#efefef'},
        Knuckleball: {ballCode: 'Knuckleball', ballName: '너클', color: '#333'},
        Sweeper: {ballCode: 'Sweeper', ballName: '스위퍼', color: '#050099'}
    };

    const [cookies] = useCookies(['hiball_token']);
    const [pitchData, setPitchData] = useState([]);

    let {playerId, type} = profile;
    let dateObj = dateSetting();
    let [season, setSeason] = useState(dateObj['selectboxSeason']);
    let todaySeason = (new Date()).getFullYear();
    const { t } = useTranslation();

    useEffect(() => {
        let params = {
            recordType: 'digestRecord', recordName: 'selectPitchLog',
            seasons: season,
            gameTypeCode: 4201,
            authToken: JSON.stringify(cookies['hiball_token']),
            pitcherIds: playerId
        }

        let ballCodeKey = Object.keys(ballCodeObj);

        axios({
            url : `${process.env.REACT_APP_API_URL}`, params
        }).then((result) => {
            let filterData = _.filter(result['data']['result']['ballList'], (item, idx) => {
                let condi = false;
                if(ballCodeKey.indexOf(item['taggedPitchType']) > -1) {
                    condi = true;
                }
                
                return condi;
            });
            let groupData = _.groupBy(filterData, (item, idx) => {
                return item['taggedPitchType'];
            });

            let resultObj = {};
            let ballArr = [];
            let totalCnt = filterData['length'];

            _.forEach(groupData, (item, idx) => {
                let ballTypeTotalSpeed = 0;

                let groupingData = _.countBy(item, (innerItem) => {
                    ballTypeTotalSpeed += innerItem['ball_speed'];
                    return innerItem['ball_speed'];
                });

                let innerArr = [];
                _.forEach(groupingData, (innerItem, innerIdx) => {
                    if(innerIdx*1 > 90) {
                        let innerObj = {
                            count: ((innerItem/totalCnt)*100).toFixed(3) ,speed: innerIdx*1
                        };
                        innerArr.push(innerObj)
                    }
                });

                resultObj[idx] = _.sortBy(innerArr, 'speed');

                let avgSpeed = (item['length'] !== 0) ? (ballTypeTotalSpeed/item['length']).toPrecision(3) : 0
                let percent = (totalCnt !== 0) ? Math.round(((item['length']/totalCnt)*100)) : 0;
                ballArr.push({ 
                    color: ballCodeObj[idx]['color'],
                    code: idx,
                    type: ballCodeObj[idx]['ballName'],
                    count: item['length'],
                    data: resultObj[idx],
                    avgSpeed, percent
                });
            });

            let sortArr = _.sortBy(ballArr, (item) => item['percent']).reverse().slice(0, 4);
            setPitchData(sortArr);
        });
    }, [season]);

    function seasonHandler(event) {
        let value = event.target.value;
        setSeason(value);
    }

    return (
        <>
        <div style={{position:'absolute', top: '7px', left: '7px'}}>
            <Form.Group onChange={seasonHandler} style={{display:'inline-block', height: '29px'}}>
                <Form.Select size="sm" defaultValue={dateObj['selectboxSeason']}>
                    <option value={todaySeason-2}>{todaySeason-2}</option>
                    <option value={todaySeason-1}>{todaySeason-1}</option>
                    <option value={todaySeason}>{todaySeason}</option>
                </Form.Select>
            </Form.Group>
        </div>
        <div className="boxTitle"><img src={ballImage} style={{height:'25px'}} /> {t('pitchArsenal')}</div>
        <div>
            {
                pitchData.length === 0 ?
                <div style={{textAlign:'center', height:'450px', 
                display: 'flex',justifyContent: 'center', alignItems: 'center'}}>
                    No Data
                </div>
                :
                <DistributionChart data={pitchData}/>
            }
        </div>
        </>
    )
}

export default PitchDistributionChartMain;